import { buildApiUrl } from '../../utils/build-api-url';
import type { IParams, IResponse, ISearch } from '../../types';
import { fetchGet } from '../service';

export type SearchAttributes = {
  cmsNativeLanguage?: string;
  pimLanguage?: string;
  term?: string;
  params?: IParams;
  filterType?: string[];
  filterLanguage?: string[];
  groupIds?: number[];
  offset?: number;
  rows?: number;
  searchObject?: object | null;
  filterVariant?: string[];
};

export async function search({
  cmsNativeLanguage = 'DE-DE',
  pimLanguage = 'de',
  term,
  params,
  filterType,
  filterLanguage,
  groupIds,
  offset = 0,
  rows = 12,
  searchObject = null,
  filterVariant,
}: SearchAttributes = {}): Promise<IResponse<ISearch> | null> {
  const trimmedTerm = term?.trim().replace(/\s+/g, ' ');
  const query = {
    cmsNativeLanguage,
    pimLanguage,
    start: !searchObject && (!groupIds || groupIds.length === 0) ? String(offset) : undefined,
    rows: !searchObject && (!groupIds || groupIds.length === 0) ? String(rows) : undefined,
    groupId:
      !searchObject && groupIds && groupIds.length > 0
        ? groupIds.map((grpId) => String(grpId))
        : [],
    searchTerm: trimmedTerm ? trimmedTerm : undefined,
    filterType: filterType?.length ? filterType : undefined,
    filterLanguage: filterLanguage?.length ? filterLanguage : undefined,
    searchParams: params?.length ? params.map((item) => JSON.stringify(item)) : undefined,
    search: searchObject ? JSON.stringify(searchObject) : undefined,
    filterProducts: searchObject && filterVariant ? filterVariant : undefined,
  };
  const url = buildApiUrl('search', query);

  const data = await fetchGet<ISearch>(url);

  return data;
}
